import { createIntl, createIntlCache, IntlShape } from 'react-intl'

import { messages } from '@i18n/index'

const AVAILABLE_LOCALES = ['en-US', 'fr-FR', 'pt-BR']

export const DEFAULT_LOCALE = AVAILABLE_LOCALES[0]

export const LOCALE_FALLBACKS: { [key: string]: string } = {
  en: 'en-US',
  fr: 'fr-FR',
  pt: 'pt-BR',
}

export const getLocale = (): string => {
  let locale = DEFAULT_LOCALE
  ;(window.navigator.languages || [window.navigator.language]).find((lang) => {
    if (lang) {
      if (AVAILABLE_LOCALES.includes(lang)) {
        locale = lang
        return true
      }
      const fallback = LOCALE_FALLBACKS[lang.split('-')[0] || '']
      if (AVAILABLE_LOCALES.includes(fallback)) {
        locale = fallback
        return true
      }
    }
    return false
  })
  return locale
}

export const getIntl = (): IntlShape => {
  const cache = createIntlCache()
  const locale = getLocale()

  return createIntl(
    {
      locale,
      messages: messages[locale],
    },
    cache,
  )
}
